"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFiltersState = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SET_TYPE = 'SET_TYPE';
var SET_CATEGORIES = 'SET_CATEGORY';
var UNSET_TYPE = 'UNSET_TYPE';
var UNSET_CATEGORY = 'UNSET_CATEGORY';
var SET_MIN_PRICE = 'SET_MIN_PRICE';
var SET_MAX_PRICE = 'SET_MAX_PRICE';
var SET_GIFT_CARD_PRICE = 'SET_GIFT_CARD_PRICE';
var SET_DONATION_AMOUNT = 'SET_DONATION_AMOUNT';
var SET_BUDGET = 'SET_BUDGET';
/**
 * @typedef FilterState
 * @property {Array<number>} types
 * @property {Array<number>} categories
 */

/**
 * @typedef FilterAction
 * @property {string} type
 * @property {*} value
 */

/**
 * @typedef FilterActions
 * @property {function (Array<number>): FilterAction} setCategories
 * @property {function (number): FilterAction} setType
 * @property {function (number): FilterAction} unsetType
 * @property {function (number): FilterAction} unsetCategory
 */

/**
 * @param {FilterState} state
 * @param {FilterAction} action
 * @returns {FilterState}
 */

var filtersReducer = function filtersReducer(state, action) {
  switch (action.type) {
    case SET_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          types: [].concat((0, _toConsumableArray2["default"])(state.types), [action.value])
        });
      }

    case UNSET_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          types: state.types.filter(function (type) {
            return type !== action.value;
          })
        });
      }

    case SET_CATEGORIES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: action.value
        });
      }

    case UNSET_CATEGORY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: state.categories.filter(function (cat) {
            return cat !== action.value;
          })
        });
      }

    case SET_MIN_PRICE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          price: _objectSpread(_objectSpread({}, state.price), {}, {
            minPrice: action.value
          })
        });
      }

    case SET_MAX_PRICE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          price: _objectSpread(_objectSpread({}, state.price), {}, {
            maxPrice: action.value
          })
        });
      }

    case SET_GIFT_CARD_PRICE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          price: _objectSpread(_objectSpread({}, state.price), {}, {
            giftCardPrice: action.value
          })
        });
      }

    case SET_DONATION_AMOUNT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          price: _objectSpread(_objectSpread({}, state.price), {}, {
            donationAmount: action.value
          })
        });
      }

    case SET_BUDGET:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          price: action.value
        });
      }

    default:
      {
        throw new Error("Uknown action for Marketplace filters", action);
      }
  }
};
/**
 * @function
 * @param {FilterState} initialFilters
 * @returns {any[]}
 */


var useFiltersState = function useFiltersState(initialFilters) {
  var _useReducer = (0, _react.useReducer)(filtersReducer, initialFilters),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var setType = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_TYPE,
      value: value
    });
  }, []);
  var unsetType = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: UNSET_TYPE,
      value: value
    });
  }, []);
  var setCategories = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_CATEGORIES,
      value: value
    });
  }, []);
  var unsetCategory = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: UNSET_CATEGORY,
      value: value
    });
  }, []);
  var setMinPrice = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_MIN_PRICE,
      value: value
    });
  }, []);
  var setMaxPrice = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_MAX_PRICE,
      value: value
    });
  }, []);
  var setGiftCardPrice = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_GIFT_CARD_PRICE,
      value: value
    });
  }, []);
  var setDonationAmount = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_DONATION_AMOUNT,
      value: value
    });
  }, []);
  var setBudget = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: SET_BUDGET,
      value: value
    });
  }, []);
  var actions = (0, _react.useMemo)(function () {
    return {
      setType: setType,
      unsetType: unsetType,
      setCategories: setCategories,
      unsetCategory: unsetCategory,
      setMinPrice: setMinPrice,
      setMaxPrice: setMaxPrice,
      setGiftCardPrice: setGiftCardPrice,
      setDonationAmount: setDonationAmount,
      setBudget: setBudget
    };
  }, [setCategories, setType, unsetType, unsetCategory, setMinPrice, setMaxPrice, setGiftCardPrice, setDonationAmount, setBudget]);
  return [state, actions];
};

exports.useFiltersState = useFiltersState;